import { render, staticRenderFns } from "./sopList.vue?vue&type=template&id=5d493702&scoped=true&"
import script from "./sopList.vue?vue&type=script&lang=js&"
export * from "./sopList.vue?vue&type=script&lang=js&"
import style0 from "./sopList.vue?vue&type=style&index=0&id=5d493702&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d493702",
  null
  
)

export default component.exports